"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelJSONModel = void 0;
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const lodash_1 = __importDefault(require("lodash"));
const FunnelChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/model/FunnelChartSettingsJSONModel");
const QueryEventVariantsJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantsJSONModel");
class FunnelJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.funnelQueryJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel();
        this.chartSettingsJSONModel = new FunnelChartSettingsJSONModel_1.FunnelChartSettingsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.funnelQueryJSONModel.reset();
            this.chartSettingsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.funnelQueryJSONModel.overwriteFromSerializedState(serializedState.funnelQuery);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                funnelQuery: this.funnelQueryJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getFunnelQueryJSONModel = () => this.funnelQueryJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.FunnelJSONModel = FunnelJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
FunnelJSONModel.isModelEmpty = (serializedState) => {
    const compositeChartJSONModel = new FunnelJSONModel(serializedState);
    return compositeChartJSONModel.getFunnelQueryJSONModel().getNumberOfQueryEventVariants() === 0;
};
FunnelJSONModel.makeModelStateClean = (serializedState) => {
    const jsonModel = new FunnelJSONModel(serializedState);
    jsonModel.getFunnelQueryJSONModel().removeNotFilledQueryEventVariants();
    return jsonModel.serialize();
};
